/*
 * Public API Surface of plugin-rating-bar
 */

export * from './lib/plugin-rating-bar.component';
export * from './lib/plugin-rating-bar.module';
